<script lang="ts">
	import { onDestroy } from 'svelte';
	import type { ScrollDirection } from './types/scroll';

	interface Props {
		active?: boolean;
		duration?: number;
		throttle?: number;
		onstart?: (direction: ScrollDirection) => void;
		onchange?: (direction: ScrollDirection) => void;
		onscroll?: (y: number) => void;
		onend?: (direction: ScrollDirection) => void;
	}

	let {
		active = true,
		duration = 150,
		throttle = 0,
		onstart,
		onchange,
		onscroll,
		onend
	}: Props = $props();

	let isScrolling = false;
	let lastScrollY: number;
	let scrollDir: ScrollDirection = 'down';
	let scrollTimeout: NodeJS.Timeout;
	let throttleTimeout: NodeJS.Timeout | undefined;

	function handleScrollEnd() {
		isScrolling = false;
		onend?.(scrollDir);
	}

	function handleScroll() {
		if (throttleTimeout !== undefined) return;

		if (lastScrollY) {
			const dir = lastScrollY >= window.scrollY ? 'up' : 'down';
			const hasIosBounce = window.scrollY < 0;
			if (dir !== scrollDir && !hasIosBounce) {
				onchange?.(dir);
			}
			scrollDir = dir;
		}
		lastScrollY = window.scrollY;

		if (!isScrolling) {
			onstart?.(scrollDir);
			isScrolling = true;
		}

		onscroll?.(lastScrollY);

		clearTimeout(scrollTimeout);
		scrollTimeout = setTimeout(handleScrollEnd, duration);

		clearTimeout(throttleTimeout);
		if (throttle > 0) {
			throttleTimeout = setTimeout(() => (throttleTimeout = undefined), throttle);
		}
	}

	onDestroy(() => {
		clearTimeout(scrollTimeout);

		if (throttleTimeout) {
			clearTimeout(throttleTimeout);
		}
	});

	$effect(() => {
		if (!active) {
			clearTimeout(scrollTimeout);

			if (throttleTimeout) {
				clearTimeout(throttleTimeout);
			}
		}
	});
</script>

<svelte:window onscroll={active ? handleScroll : undefined} />
